import { useTranslation } from "react-i18next";

import { cap } from "../../../utils/utils";
import { useSelector } from "react-redux";

function InputLingoPlans({ type, name, value, onChange, required, error }) {
  const { t } = useTranslation();
  const { lingoPlans } = useSelector((state) => state.genericReducer);

  return (
    <div className={`lineInput lineInput${type} lineInput${cap(name)} ${error ? "invalid" : ""}`}>
      <label htmlFor={name}>{t("REQUESTED_PLAN")}</label>
      {required && <span>{t("REQUIRED_FIELD")}</span>}
      <select name={name} value={value} onChange={(e) => onChange(e, name)}>
        <option value={""}> {t("SELECT")}</option>
        {lingoPlans?.map((option) => (
          <option key={option.nameEnglish} value={option.id}>
            {" "}
            {option.nameEnglish}{" "}
          </option>
        ))}
      </select>
    </div>
  );
}

export default InputLingoPlans;
